import { TweenMax } from "gsap/TweenMax";
import ScrollMagic from "scrollmagic";
import "imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap";
// import "imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js";

var controller = new ScrollMagic.Controller();

if (document.querySelector(".grand-top-symbol")) {
  function pathPrepare($el) {
    var lineLength = $el[0].getTotalLength();
    $el.css("stroke-dasharray", lineLength);
    $el.css("stroke-dashoffset", 0);
  }

  var $route = $("path#route-1");

  var drawArea =
    768 <= $(window).width()
      ? document.querySelector(".grand-top-symbol").clientHeight
      : document.querySelector(".grand-top-symbol").clientHeight * 3;

  // prepare SVG
  pathPrepare($route);

  // build tween
  var route_1 = new TimelineMax().add(
    TweenMax.to($route, 1, {
      strokeDashoffset: $route[0].getTotalLength() + "px",
      ease: Linear.easeNone,
    })
  );

  var drawAction = new ScrollMagic.Scene({
    triggerElement: ".grand-top-symbol",
    duration: drawArea,
    tweenChanges: true,
  })
    .setTween(route_1)
    // .addIndicators()
    .addTo(controller);

  var drawShow = new ScrollMagic.Scene({
    triggerElement: ".grand-top-symbol",
    duration: drawArea,
    tweenChanges: true,
    offset: -500,
  })
    // .addIndicators()
    .addTo(controller);

  drawShow.on("enter", () => {
    //triggerElementを過ぎたとき
    TweenMax.to($(".grand-top-symbol"), 0.3, {
      opacity: 1,
      ease: Linear.easeNone,
    });
  });
  drawShow.on("leave", () => {
    //triggerElementを抜けたとき
  });
}
